/***
 * Model used to fetch and update the user's privacy.
 */
import Backbone from 'backbone';
import AnalyticsUtil from 'utils/AnalyticsUtil';
import { PRIVACY_VISIBILITY_OPTIONS } from 'utils/PrivacyUtils';

let Visibility = PRIVACY_VISIBILITY_OPTIONS;

const isValueDifferentInUserCustomPrivacy = function(privacyList) {
    if (privacyList && privacyList.length) {
        return privacyList.find((item, index) => {
            if (item.subcategoryDetails && item.subcategoryDetails.accessRule) {
                let nextIndexItem = index + 1 < privacyList.length ? index + 1 : index;
                let nextItemAccessRule = privacyList[nextIndexItem].subcategoryDetails.accessRule;

                return item.subcategoryDetails.accessRule !== nextItemAccessRule;
            }
        });
    }
};

let UsersPrivacySettings = Backbone.Model.extend({
    urlRoot: '/privacysettings-service/privacy-settings',
    backend: 'gcapi',

    getActivityPrivacySettings: function() {
        return this.get('activityPrivacySettings');
    },

    getProfilePrivacySettings: function() {
        return this.get('profilePrivacySettings');
    },

    getWellnessPrivacySettings: function() {
        return this.get('wellnessPrivacySettings');
    },

    getActivityCategoryDetails: function() {
        return this.get('activityPrivacySettings') && this.get('activityPrivacySettings').categoryDetails;
    },

    getActivityCategoryAccessRule: function() {
        return (
            this.get('activityPrivacySettings') &&
            this.get('activityPrivacySettings').categoryDetails &&
            this.get('activityPrivacySettings').categoryDetails.categoryAccessRule
        );
    },

    getStepsCategoryAccessRule: function() {
        return (
            this.get('wellnessPrivacySettings') &&
            this.get('wellnessPrivacySettings').categoryDetails &&
            this.get('wellnessPrivacySettings').categoryDetails.categoryAccessRule
        );
    },

    getProfileCategoryAccessRule: function() {
        return (
            this.get('profilePrivacySettings') &&
            this.get('profilePrivacySettings').categoryDetails &&
            this.get('profilePrivacySettings').categoryDetails.categoryAccessRule
        );
    },

    getActivitySubcategoryPrivacySettings: function() {
        return this.get('activityPrivacySettings') && this.get('activityPrivacySettings').subcategoryPrivacySettings;
    },

    setActivityPrivacySettings: function(values) {
        this.set('activityPrivacySettings', values);
    },

    setCategoryAccessRule: function(categoryAccessRule, currentPrivacyValues) {
        if (categoryAccessRule && currentPrivacyValues) {
            let currentCategoryPrivacyValues = this.get(currentPrivacyValues);
            if (typeof currentCategoryPrivacyValues === 'object') {
                let setValues = {
                    ...currentCategoryPrivacyValues,
                    categoryDetails: {
                        ...currentCategoryPrivacyValues.categoryDetails,
                        categoryAccessRule: categoryAccessRule
                    }
                };
                this.set(currentPrivacyValues, setValues);
            }
        }
    },

    setSpecificPrivacyCustomSetting: function(privacySetting, privacySubcategoryType, accessRule) {
        let currentActivityPrivacyValues = this.get(privacySetting);
        let setValues = {
            ...currentActivityPrivacyValues
        };

        let changedCategoryIndex = setValues.subcategoryPrivacySettings.findIndex((item, index) => {
            return item.privacySubcategoryType === privacySubcategoryType;
        });
        setValues.subcategoryPrivacySettings[changedCategoryIndex] = {
            ...setValues.subcategoryPrivacySettings[changedCategoryIndex],
            subcategoryDetails: {
                ...setValues.subcategoryPrivacySettings[changedCategoryIndex].subcategoryDetails,
                accessRule: accessRule
            }
        };

        this.set(privacySetting, setValues);
    },

    getActivityPrivacyBasedOnParentActivityType: function(associatedParentActivityType, isUsingId) {
        let allSubcategories = this.getActivitySubcategoryPrivacySettings();
        let returnSubcategory = null;

        if (allSubcategories) {
            returnSubcategory = allSubcategories.find((activityTypePrivacy) => {
                if (isUsingId) {
                    return (
                        activityTypePrivacy &&
                        activityTypePrivacy.associatedParentActivityTypeIds.indexOf(associatedParentActivityType) !== -1
                    );
                } else {
                    return (
                        activityTypePrivacy &&
                        activityTypePrivacy.privacySubcategoryType === associatedParentActivityType
                    );
                }
            });
        }

        return returnSubcategory;
    },

    url: function() {
        return this.urlRoot;
    }
});

UsersPrivacySettings.Visibility = Visibility;
UsersPrivacySettings.isValueDifferentInUserCustomPrivacy = isValueDifferentInUserCustomPrivacy;

export default UsersPrivacySettings;
